import type { JSX } from "react";
import { memo } from "react";
import clsx from "clsx";

import styles from "./styles.module.scss";

import { Icon } from "@components/atoms/icons";
import type { IPaginationActionProps } from "@components/molecules/pagination/types";
import { PaginationLink } from "@components/molecules/pagination/paginationLink";

export const PaginationNext = memo(function PaginationNext({
  disabled,
  ...props
}: IPaginationActionProps): JSX.Element {
  return (
    <PaginationLink
      aria-label={"Go to next page"}
      size={"default"}
      className={clsx(styles.nextButton)}
      {...props}
      disabled={disabled}
    >
      {props.children}
      <Icon name={"AltArrowLeft"} type={"linear"} />
    </PaginationLink>
  );
});
